'use client'
import { useEffect } from 'react'
import { useRouter } from 'next/navigation'

export default function RedirectHandler({ appLink, fallbackLink }) {
    const router = useRouter()

    useEffect(() => {
        if (typeof window === 'undefined') return

        const userAgent = navigator.userAgent
        const isMobile = /iPhone|iPad|iPod|Android/i.test(userAgent)
        const isAndroid = /Android/i.test(userAgent)
        if (isMobile && isAndroid) {
            const startTime = Date.now()
            let hasAppOpened = false
            let fallbackTimeout

            // Visibility change listener to check if user leaves (app opened)
            const handleVisibilityChange = () => {
                if (document.hidden) {
                    hasAppOpened = true
                    clearTimeout(fallbackTimeout)
                }
            }
            document.addEventListener('visibilitychange', handleVisibilityChange)

            // Attempt to open the app
            window.location.href = appLink

            // Fallback: If the user is still on the page after 2s, redirect to web
            fallbackTimeout = setTimeout(() => {
                if (!hasAppOpened && Date.now() - startTime < 2000) {
                    window.location.href = fallbackLink
                }
            }, 2000)

            return () => {
                document.removeEventListener('visibilitychange', handleVisibilityChange)
                clearTimeout(fallbackTimeout)
            }
        } else {
            router.replace(fallbackLink)
        }
    }, [appLink, fallbackLink, router])

    return null
}
